<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/wofangxinxi-icon.png" />
				数据统计
			</el-col>
		</el-row>

		<div style="background-color: #fff;">
			<el-form label-width="100px" style="border-bottom: 4px solid #F3F4F4;padding:20px 20px 0px;">
				<el-row>
					<el-col :md="4" :lg="4">
						<el-form-item label="时间：">
							<el-select v-model="timeType" placeholder="请选择" @change="selectChange" style="width: 95%;">
								<el-option label="月" value="月"></el-option>
								<el-option label="年" value="年"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="12">
          <!-- 月份选择 -->
          <el-date-picker
            v-if="timeType == '月'"
            v-model="value1"
            type="monthrange"
            @change="timeYearChange"
            range-separator="至"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            start-placeholder="开始月份"
            end-placeholder="结束月份">
          </el-date-picker>
					<!-- 年份选择 -->
          <div v-else>
            <el-date-picker
              v-model="startTime"
              :picker-options="startDatePicker"
              value-format="yyyy"
              style="width:140px;"
              type="year"
              format="yyyy 年"
              placeholder="开始时间"
              @change="startTimeChange"
            >
            </el-date-picker>
            ~
            <el-date-picker
              v-model="endTime"
              value-format="yyyy"
              style="width:140px;"
              :picker-options="endDatePicker"
              type="year"
              format="yyyy 年"
              placeholder="结束时间"
              @change="endTimeChange"
            >
            </el-date-picker>
            </div>
					</el-col>
					<el-col :md="4" :lg="8">
						<div style="text-align: right;line-height: 60px;font-weight: bold;">单位：元</div>
					</el-col>
				</el-row>
			</el-form>

			<el-row style="border-bottom: 4px solid #F3F4F4;">
				<el-col :span="8" style="border-right: 4px solid #F3F4F4;">
					<el-table  :data="dataList" style="width: 100%;" max-height="400" >
						<el-table-column prop="name" label="项目" header-align="center" align="center" show-overflow-tooltip min-width="200">
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.alt" placement="bottom-start">
                  <span style="cursor:pointer">{{scope.row.name}}</span>
                </el-tooltip>
                
              </template>
            </el-table-column>
						<el-table-column prop="num" label="数量" header-align="center" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="price" label="金额" header-align="center" align="center" show-overflow-tooltip></el-table-column>
					</el-table>
				</el-col>
				<el-col :span="16"><div ref="myEchart" style="width: 90%; height: 327px;margin-top: 27px;margin-left: 30px;"></div></el-col>
			</el-row>

			<el-row style="border-bottom: 4px solid #F3F4F4;padding:0px 20px;">
				<el-col :span="12" style="border-right: 4px solid #F3F4F4;"><div ref="myEcharttwo" style="width: 100%; height: 327px;margin-top: 27px;"></div></el-col>
				<el-col :span="12"><div ref="myEchartthree" style="width: 90%; height: 327px;margin-top: 27px;margin-left: 30px;"></div></el-col>
			</el-row>
		</div>

      
	</el-card>
</template>
<script>
import echarts from 'echarts'
export default {
  name: 'analyzeSystem',
  props: {
    className: {
      type: String,
      default: 'yourClassName'
    },
    id: {
      type: String,
      default: 'yourID'
    },
    width: {
      type: String,
      default: '500px'
    },
    height: {
      type: String,
      default: '500px'
    }
  },
  data () {
    return {
      value1:'',
      timeType:'月',
      startTime:'',
      endTime:'',
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),   
      dataList: [
        { name: '发布任务', num: 10, price: 200 },
        { name: '已接受任务', num: 10, price: 200 },
        { name: '任务人数', num: 10, price: 200 },
        { name: '累计合同', num: 10, price: 200 },
        { name: '已到期合同', num: 10, price: 200 },
        { name: '即将到期合同', num: 10, price: 200 },
        { name: '企业承担服务费合同', num: 10, price: 200 },
        { name: '个人承担服务费合同', num: 10, price: 200 },
        { name: '累计结算', num: 10, price: 200 },

        { name: '结算人次', num: 10, price: 200 },

        { name: '开票量', num: 10, price: 200 },
        { name: '开票企业', num: 10, price: 200 },
        
        
        // { name: '到账成功金额', num: 10, price: 200 },
        { name: '男性会员数量', num: 10, price: 200 },
        { name: '女性会员数量', num: 10, price: 200 },
        // { name: '60岁以上会员', num: 10, price: 200 },
        // { name: '董监高数量', num: 10, price: 200 },
        
      ],
      data: [],
      yearlist: 2020,
      month: '1',
      year: 2020,
      chart: '',
      charttwo: '',
      chartthree: ''
    }
  },
  mounted () {
		 var myDate = new Date()
		 this.yearlist = myDate.getFullYear()
		 this.year = this.yearlist
		 this.month = String((myDate.getMonth() + 1) < 10 ? '0' + (myDate.getMonth() + 1) : (myDate.getMonth() + 1))
     this.value1 = [this.year + '-' + this.month,this.year + '-' + this.month]
     this.startTime = this.value1[0]
     this.endTime = this.value1[1]
    this.getinfo()
    window.addEventListener('resize', () => {
      this.chart.resize()
      this.charttwo.resize()
      this.chartthree.resize()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    // 切换选择日期格式
    selectChange(e){
      this.startTime = '';
      this.endTime = '';
      this.timeType = e;
      if(e == '月'){
        this.value1 = [this.year + '-' + this.month,this.year + '-' + this.month]
        this.startTime = this.value1[0]
        this.endTime = this.value1[1]
      }else{
        this.startTime = this.year.toString()
        this.endTime = this.year.toString()
      }
      this.getinfo()
    },
    // 选择月份
    timeYearChange(e){
      if(e){
        this.value1 = e;
        this.startTime = e[0];
        this.endTime = e[1];
      }else{
        this.startTime = '';
        this.endTime = '';
      }
      this.getinfo()
    },
    // 选择年份
    startTimeChange(e){
      if(e){
        this.startTime = e;
      }else{
        this.startTime = '';
      }
      this.getinfo()
    },
    endTimeChange(e){
      if(e){
        this.endTime = e;
      }else{
        this.endTime = '';
      }
      this.getinfo()
    },
    // 选择年份范围选择时开始时间不能大于结束时间，结束时间不能小于开始时间
 
    // 提出开始时间必须小于提出结束时间
    beginDate() {
      let self = this
        return {
          disabledDate(time) {
            if (self.endTime !== '') {
              let fixedTime = new Date(time)
              return fixedTime.getFullYear() > self.endTime
            }
          }
        }
      },
      // 提出结束时间必须大于提出开始时间
      processDate() {
        let self = this
        return {
          disabledDate(time) {
            let fixedTime = new Date(time)
            return fixedTime.getFullYear() < self.startTime
          }
        }
      },
		 getinfo () {
			 // 获取数据
			 this.$http.get(`/sys/plat/task/statistics?startTime=` + this.startTime + `&endTime=` + this.endTime).then(({ data: res }) => {
			     if (res.code !== 0) {
			         return this.$message.error(res.msg)
			     }
			 			 this.data = res.data
            //  发布任务
			 			 this.dataList[0].num = res.data.monthPublishNum
			 			//  this.dataList[0].price = res.data.monthPublishAmount
			 			 this.dataList[0].price = ''
			 			 this.dataList[0].alt = '审核通过的任务数量'
            //  已接受任务
			 			 this.dataList[1].num = res.data.monthAcceptNum
			 			 this.dataList[1].price = ''
			 			 this.dataList[1].alt = '导入结算的人数'
              //任务人数
             this.dataList[2].num = res.data.successfulNum
             this.dataList[2].price = res.data.successfulAmount
             this.dataList[2].alt = '到账成功的人数及到账成功金额'
              // 累计合同
			 			 this.dataList[3].num = res.data.monthContractNum
			 			 this.dataList[3].price = ''
			 			 this.dataList[3].alt = '累计审核通过的合同数量'
			 			//  this.dataList[3].price = res.data.monthContractAmount
             
             //已到期合同
             this.dataList[4].num = res.data.hasExpiredContracts
             this.dataList[4].price = ''
             this.dataList[4].alt = '到期的合同数量'
            //即将到期合同
             this.dataList[5].num = res.data.expiringSoonContracts
             this.dataList[5].price = ''
             this.dataList[5].alt = '即将到期的合同数量'
              //企业承担服务费合同
             this.dataList[6].num = res.data.type1Contracts
             this.dataList[6].price = ''
             this.dataList[6].alt = '企业承担服务费的合同数,金额不统计,显示为空'
            //个人承担服务费合同
             this.dataList[7].num = res.data.type2Contracts
             this.dataList[7].price = ''
             this.dataList[7].alt = '个人承担服务费的合同数,金额不统计,显示为空 '
             //  累计结算
			 			 this.dataList[8].num = res.data.monthDealNum
			 			 this.dataList[8].price = res.data.monthDealAmount
			 			 this.dataList[8].alt = '审核通过的结算单数量及金额'
            //结算人次
             this.dataList[9].num = res.data.settlementNum
             this.dataList[9].price = ''
             this.dataList[9].alt = '结算人次'
            //  开票量
			 			 this.dataList[10].num = res.data.monthTicketNum
			 			 this.dataList[10].price = res.data.monthTicketAmount
			 			 this.dataList[10].alt = '开票张数及开票金额'
             //  开票企业
			 			 this.dataList[11].num = res.data.ticketCompanyNum
			 			 this.dataList[11].price = ''
			 			 this.dataList[11].alt = '开票完成的企业数量及开票金额'
            //男性会员数量
             this.dataList[12].num = res.data.maleMembersNum
             this.dataList[12].price = ''
			 			 this.dataList[12].alt = '男性用户人数'
            //女性会员数量
             this.dataList[13].num = res.data.femaleMembersNum
             this.dataList[13].price = ''
			 			 this.dataList[13].alt = '女性用户人数'
            //60岁以上会员
            //  this.dataList[14].num = res.data.over60yearsOld
            //  this.dataList[14].price = ''
            //董监高数量
            //  this.dataList[15].num = res.data.companyStaffNum
            //  this.dataList[15].price = ''
			 			 this.initChart()
			 				this.initChartTwo()
			 				this.initChartThree()
			 }).catch(() => {
			 })
		 },
    initChart () {
			 let that = this
			 let x = []
			 let y1 = []
			 let y2 = []
			 let y3 = []
			 let y4 = []
			 let y5 = []
			 for (let i = 0; i < this.data.monthData.length; i++) {
				 x.push(this.data.monthData[i].dayName)
				 y1.push(this.data.monthData[i].publishAmount)
				 y2.push(this.data.monthData[i].acceptAmount)
				 y3.push(this.data.monthData[i].contractAmount)
				 y4.push(this.data.monthData[i].ticketAmount)
				 y5.push(this.data.monthData[i].dealAmount)
			 }
      this.chart = echarts.init(this.$refs.myEchart)

			 let options = {
        backgroundColor: '#fff',
				 grid: {
          left: '0%',
          right: '0%',
          bottom: '3%',
          containLabel: true
        },
        title: { text: '趋势图' },
        color: ['#FDE752', '#5295FD', '#3D62F6', '#47D0C6', '#EA8A5B'],
        legend: {
          left: 'center',
          data: ['发布任务', '接受任务', '累计合同', '累计开票', '累计结算'],
          type: 'scroll'
        },
        dataZoom: {
          start: 0, // 默认为0
          end: x.length > 15 ? 50 : 100, // 默认为100
          type: 'slider',
          show: x.length > 15

        },
        xAxis: {
          type: 'category',
          data: x,
          'axisLine': { // y轴
			  'show': true,
			  lineStyle: {
				   color: ['#EEEEEE'],
				   width: 1,
				   type: 'solid'
			  }

          },
          axisLabel: {
			   show: true,
            textStyle: {
				  color: '#999' // 更改坐标轴文字颜色
            }
			 },
          'axisTick': { // y轴刻度线
			  'show': false
          }
        },

        toolbox: {
          left: 'right',
          feature: {
            myTool: {
              show: true,
              title: '全部',
              icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFEElEQVR4Xu1bXWgcVRT+zt3QZCfNQ/WlWhVBUUlF0NT60501VYktImhEsFhFtFgETV6ipTU7me62iloUiyKKFaSKoljEItVSbexsjdUERUxE8UEaDb7YPqQ7k8TMPTK7M5PJEtvSzGwCe+dp987M+Ztzzz2/hMilG6duI6ZOJroWwE3Re/P8/ScBAxI8Usw3m6eDlTFKpgC1cgX/RfPEG319gJh/YOJ9Vn7pl8ENCn5kzIkukvKVGBH+H6gxZnQWC9qx6gd0w/4WwA1J08BCdBfNpt0enrIAMubEOpLyQNKIo/DtFeklQ5vp32BNz9nHQbi4VjSwEOuLZtPnpJul6yBpKIJ4GsyHmOXzcRFDlFoPwt0ArghgMvBaMa894f3Xc/aLIPRE8P0GxifMbmwfhUhsAdHtABpCPILbKNvnvMHMj/mLUyzdO4o7WvrjYj6Ac+sz9orpBjzNjK5gzZXicu93Ssjfwz1J2N0wjRe+2qn9FTcNmd7xdhKpLwAsKas/0ZukG/YggDZvgUF7ivn0prgRB/DW9JVWCabvI1rQ6e/DfcGaJL7+6PZmj6ZErozhvEXgR33gQ54AOCRIumuT+PpRTvScfRiE9orAeXtFANRXfobRbxW0tYlw7gP1teBwqHFKAEoD1BZQNkAZQV8CrE4BdQwqP0A5QgnEAcoTjEhAucIqFlDBkIoGVTis8gEqIbKoMkJe8vHCckaK0V0saOV8eVKXbjg/A7yyDJ/E45VUmHzdxzdl5bXGpHB7cPVcaRuIdvo4xihr2J8ycFclN4dBmU53FLfSySSIyBj2fQR8GObjBNZU+MfREB/jSaugvZoEfl8AJ0C0zOd3P3mlqDApWUkVvw2XPzuyQwsztXEQk8mV2ogoku2lX1NifJUH25VLfwRwWUUbMArBe13ij74xy+uxXHru1MMg0QFgQwDQS8qWK0Oz1HLmbny1AcIFAK6MciKYsl8X0pa3ljHsewiIVeBnlhoNW/n01RUBmJOtkO7wmV+K5wlP8tVFUr3POQDmdfFgOAsoIrXSMhtHwuJou8lNrnTeBXDvWbx+ro8cZ1BvMZ/eOxeArGn3sER3zFXhalQfp0R6Y79JE74dmH2/3XQulUytkt3V58pl9XsCYpRY/tTojI8c3LW8dDq4HT1/N0+mW1qZxDUSMrZiqaDUd4J4pN9M/xHFH2pAsFjXAtAN29sCD8T15eeAc9otkDGcBwm8A8AlCdLwnpXXNgbwQw3QjdI/AJ2XIOIQ9FxGsPo4TpYOPmHlm88PbYCes98H4f5ZSBlxHoM3ByXpAEf0GLwl5+iS+MhspmkczNG+hfnJxA/AIl/hA6ugbaiZI5Q1JjYz5LYZ9Y46Qi2DAFf8BEY/Ex1yx5teGniZnPlxPfN2ttfuRIruZOZHgtWyI1RLV1g3nK0APxvuvzlcYQJvOpJv3hMX41E4med4mXCcgwyUPVAC9nv9ATULhtrNyatc6f4SElUdDDGfPJHSlg+bNJWEADyYmZzdRYSgGWys9g0S0XJ8XTZIKAFE+hGUBtRjj5DaAmoLzLTkKBugbEAdNkoqI6iMoDKC0XC0EpXVU7O0sgHKBigboGyAL4H6nBhZhEawZkNT1VVgBhZ+aKpWY3Oe1mf7Su8w00OBDVgcY3O1GZxcDeItsypPjF1WQXvKE8aCDk6WU8W1Hp1ljFoFbVb9b8FGZwN1rOHw9DErr904V95/wYanA2LqcXz+P7ltGFoCGEt2AAAAAElFTkSuQmCC',
              z: '999',
              left: 'center',
              onclick: function () {
                let data = []
						 for (let i = 0; i < options.series.length; i++) {
							 options.series[i].itemStyle = { normal: { label: { show: false, color: '#333' } } }
						 }
						 options.legend.selected = {
						    // 选中'系列1'
						    '发布任务': true,
						    // 不选中'系列2'
						    '接受任务': true,
						    '累计合同': true,
						    '累计开票': true,
						    '累计结算': true
                }
						 that.chart.setOption(options)
              }
            }
          }

        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          'axisLine': { // y轴
			  'show': false

          },
          axisLabel: {
			   show: true,
            textStyle: {
				  color: '#999' // 更改坐标轴文字颜色
            }
			 },
          'axisTick': { // y轴刻度线
			  'show': false
          },
          splitLine: {
            show: true,
            lineStyle: {
				   color: ['#EEEEEE'],
				   width: 1,
				   type: 'solid'
			  }
          }
        },
        series: [{
          data: y1,
          type: 'line',
          name: '发布任务',
          smooth: true,
          lineStyle: {
            width: 3,
            color: '#FDE752'
          }
        }, {
          data: y2,
          type: 'line',
          name: '接受任务',
          smooth: true,
          lineStyle: {
            width: 3,
            color: '#5295FD'
          }
        }, {
          data: y3,
          type: 'line',
          name: '累计合同',
          smooth: true,
          lineStyle: {
            width: 3,
            color: '#3D62F6'
          }
        }, {
          data: y4,
          type: 'line',
          name: '累计开票',
          smooth: true,
          lineStyle: {
            width: 3,
            color: '#47D0C6'
          }
        }, {
          data: y5,
          type: 'line',
          name: '累计结算',
          smooth: true,
          lineStyle: {
            width: 3,
            color: '#EA8A5B'
          }
        }] }
      this.chart.on('legendselectchanged', function (obj) {
			 for (let i = 0; i < options.series.length; i++) {
				 if (obj.name == options.series[i].name) {
            options.series[i].itemStyle = { normal: { label: { show: true, color: '#333' } } }
				 } else {
				 }
			 }
			 options.legend.selected = {
			    // 选中'系列1'
			    '发布任务': obj.name == '发布任务',
			    // 不选中'系列2'
			    '接受任务': obj.name == '接受任务',
			    '累计合同': obj.name == '累计合同',
			    '累计开票': obj.name == '累计开票',
			    '累计结算': obj.name == '累计结算'
        }
			 that.chart.setOption(options)
      })
      this.chart.setOption(options, true)
    },
    initChartTwo () {
      this.charttwo = echarts.init(this.$refs.myEcharttwo)
      this.charttwo.setOption({
        backgroundColor: '#fff',
        title: { text: '执行情况分析' },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        color: ['#FDE752', '#5295FD', '#3D62F6', '#47D0C6', '#EA8A5B'],
        legend: {
          left: 'right',
          data: ['全部', '发布任务', '接受任务', '累计合同', '累计开票', '累计结算']
        },
        xAxis: {
          type: 'category',
          data: ['发布任务', '接受任务', '累计合同', '累计开票', '累计结算'],
          'axisLine': { // y轴
					  'show': true,
					  lineStyle: {
						   color: ['#EEEEEE'],
						   width: 1,
						   type: 'solid'
					  }

          },
          axisLabel: {
					   show: true,
            textStyle: {
						  color: '#999' // 更改坐标轴文字颜色
            }
					 },
          'axisTick': { // y轴刻度线
					  'show': false
          }
        },
        yAxis: {
          type: 'value',
          'axisLine': { // y轴
						  'show': false

          },
          axisLabel: {
						   show: true,
            textStyle: {
							  color: '#999' // 更改坐标轴文字颜色
            }
						 },
          'axisTick': { // y轴刻度线
						  'show': false
          },
          splitLine: {
            show: true,
            lineStyle: {
							   color: ['#EEEEEE'],
							   width: 1,
							   type: 'solid'
						  }
          }
        },
        series: [{
          data: [
            this.data.monthPublishAmount,
            this.data.monthAcceptAmount,
            this.data.monthContractAmount,
            this.data.monthTicketAmount,
            this.data.monthDealAmount
          ],
          type: 'bar',
          smooth: true,
          label: {
            normal: {
              show: true,
              position: 'top',
              color: '#333'
            }
          },
          barWidth: '32px',
          itemStyle: {
            normal: {
              barBorderRadius: [16, 16, 0, 0],
              color: function (params) {
								 var colorList = ['#FDE752', '#5295FD', '#3D62F6', '#47D0C6', '#EA8A5B']
								 return colorList[params.dataIndex]
							 }
            }
          }
        }]
      })
    },
    initChartThree () {
      this.chartthree = echarts.init(this.$refs.myEchartthree)
      this.chartthree.setOption({
        backgroundColor: '#fff',
        title: { text: '结算情况分析' },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          orient: 'vertical',
          left: '80%',
          top: '30%',
          data: ['累计合同', '累计开票', '累计结算']
        },
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center',
            formatter: '{b}\n\r{c}'
          },
          itemStyle: {
            normal: {
              barBorderRadius: [16, 16, 0, 0],
              color: function (params) {
								 var colorList = ['#3D62F6', '#47D0C6', '#EA8A5B']
								 return colorList[params.dataIndex]
							 }
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '14',
              color: '#333'
            }
          },
          labelLine: {
            show: false
          },
          data: [
            { value: this.data.monthContractAmount, name: '累计合同' },
            { value: this.data.monthTicketAmount, name: '累计开票' },
            { value: this.data.monthDealAmount, name: '累计结算' }
          ]
        }]
      })
    }
  }
}
</script>
<style>
.el-table td,
.el-table th {
	padding: 18px 0px;
}
.aui-wrapper .el-table td {
	padding: 18px 0px;
}
</style>
